// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"83c744e3","500":"03112363","590":"58a3add9","938":"e306d741"}[chunkId] + ".chunk.js";
};